import { render, staticRenderFns } from "./AwlTable.vue?vue&type=template&id=3ca4da22&"
import script from "./AwlTable.vue?vue&type=script&lang=js&"
export * from "./AwlTable.vue?vue&type=script&lang=js&"
import style0 from "./AwlTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports